import React, { useEffect } from "react";
import Lottie from "lottie-react";
import loadingAnimation from "./AnimationLoader.json";
import { useSelector } from "react-redux";

const LottieAnimation = () => {
  const { isLoading } = useSelector((state) => state.loader);

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling
    }
    return () => {
      document.body.style.overflow = "auto"; // Cleanup when component unmounts
    };
  }, [isLoading]);

  if (!isLoading) return null;

  return isLoading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "transparent",
        width: "100vw",
      }}
    >
      <div style={{ width: 100, height: 100, transform: "scale(2)" }}>
        <Lottie animationData={loadingAnimation} loop={true} />
      </div>
    </div>
  ) : null;
};

export default LottieAnimation;


// full transparent

// <div
//   style={{
//     position: "fixed",   // overlay but not blocking
//     top: 0,
//     left: 0,
//     width: "100vw",
//     height: "100vh",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     background: "transparent", // ensures no overlay color
//     zIndex: 9999, 
//     pointerEvents: "none", // let clicks go through if you want
//   }}
// >
//   <div style={{ width: 100, height: 100, transform: "scale(2)" }}>
//     <Lottie animationData={loadingAnimation} loop={true} />
//   </div>
// </div>